import { optionsToStrategy } from "@/common/utils/optionsToStrategy";

export const options = [
  {label: 'Carro', value: 'car'},
  {label: 'Motocicleta', value: 'motocycle'},
  {label: 'Equipamento manual', value: 'manual_tool'},
];

export const strategy = optionsToStrategy(options)